export const RECONCILIATION_REQUESTS_RESET_STATE = 'RECONCILIATION_REQUESTS_RESET_STATE';
export const RECONCILIATION_REQUESTS_CURRENT_ITEM = 'RECONCILIATION_REQUESTS_CURRENT_ITEM';

export const RECONCILIATION_REQUESTS_REQUEST_LOADING = 'RECONCILIATION_REQUESTS_REQUEST_LOADING';
export const RECONCILIATION_REQUESTS_REQUEST_SUCCESS = 'RECONCILIATION_REQUESTS_REQUEST_SUCCESS';
export const RECONCILIATION_REQUESTS_REQUEST_FAILED = 'RECONCILIATION_REQUESTS_REQUEST_FAILED';

export const RECONCILIATION_REQUESTS_CURRENT_ACTION = 'RECONCILIATION_REQUESTS_CURRENT_ACTION';
export const RECONCILIATION_REQUESTS_RESET_ACTION = 'RECONCILIATION_REQUESTS_RESET_ACTION';